import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus, Layers } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { WorkspaceDialog } from "./WorkspaceDialog";
import { useIsAdmin } from "@/shared/hooks/use-admin-validation";

export const NoWorkspacePlaceholder = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { isAdmin } = useIsAdmin();

  return (
    <div className="flex items-center justify-center min-h-[70vh]">
      <div className="flex flex-col items-center text-center gap-6 max-w-md px-6">

        <div className="h-20 w-20 rounded-2xl bg-primary/10 flex items-center justify-center">
          <Layers className="h-10 w-10 text-primary" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            {t("common.workspaces.emptyState.title")}
          </h1>
          <p className="text-muted-foreground leading-relaxed">
            {t("common.workspaces.emptyState.description")}
          </p>
        </div>

        {isAdmin && (
          <>
            <Button
              size="lg"
              className="gap-2 px-8"
              onClick={() => setOpen(true)}
            >
              <Plus className="h-5 w-5" />
              {t("common.workspaces.addWorkspace")}
            </Button>

            <WorkspaceDialog open={open} onOpenChange={setOpen} />
          </>
        )}
      </div>
    </div>
  );
};
